import { AddComment } from './AddComment';
import { Comment } from './Comment';
import { CommentsSectionProps } from './types';

export const CommentsSection = ({
  comments,
  commentsLoading,
  authenticatedUser,
  editingCommentId,
  editingCommentText,
  onStartEditComment,
  onCancelEditComment,
  onEditComment,
  onDeleteComment,
  updateCommentLoading,
  newComment,
  onNewCommentChange,
  onSubmitComment,
  createCommentLoading,
  onEditingCommentTextChange
}: CommentsSectionProps & {
  onEditingCommentTextChange?: (value: string) => void;
}) => {
  return (
    <div>
      <h3 className="mb-2 font-medium text-gray-900 text-lg">Comments</h3>

      {/* Comments List */}
      <div className="mb-8 space-y-6 text-muted-foreground text-sm">
        {commentsLoading ? (
          <div>Loading comments...</div>
        ) : comments.length === 0 ? (
          <div>No comments yet</div>
        ) : (
          comments.map((comment) => {
            const isOwnComment = comment.user.id === authenticatedUser.user?.id;

            return (
              <Comment
                key={comment.id}
                comment={comment}
                isOwnComment={isOwnComment}
                editingCommentId={editingCommentId}
                editingCommentText={editingCommentText}
                onStartEdit={onStartEditComment}
                onCancelEdit={onCancelEditComment}
                onEdit={onEditComment}
                onDelete={onDeleteComment}
                updateCommentLoading={updateCommentLoading}
                onEditingCommentTextChange={onEditingCommentTextChange}
              />
            );
          })
        )}
      </div>

      {/* Add Comment */}
      <AddComment
        newComment={newComment}
        onCommentChange={onNewCommentChange}
        onSubmit={onSubmitComment}
        isLoading={createCommentLoading}
        authenticatedUser={authenticatedUser}
      />
    </div>
  );
};
